import React from 'react';
import './styles.scss';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { Check } from '../../../components/atoms/icons';

interface Props {
    fullName: string;
    clientList: boolean;
    clientListLoad: boolean;
    vmList: boolean;
    vmListLoad: boolean;
}

interface RenderLinkProps {
    title: string;
    isDone: boolean;
    link:string;
    isLoading: boolean;
}

function RenderLink(props: RenderLinkProps) {
  const {
    link, isDone, title, isLoading,
  } = props;
  if (isLoading) return <Spinner animation="border" size="sm" />;
  if (isDone) {
    return (
      <div className="d-flex align-items-center">
        <div className={title !== 'Add a coffee machine' ? 'overview-intro-header-check-container me-2' : 'd-none'}>
          <Check width={12} />
        </div>
        <div className={`fz-14 me-2 text-black text-decoration-none ${isDone ? 'opacity-50' : ''}`}>
          {title}
        </div>
        <ArrowForwardIosIcon sx={{ fontSize: '16px', opacity: 0.5 }} />
      </div>
    );
  }
  return (
    <div className="d-flex align-items-center">
      <div className={title !== 'Add a coffee machine' ? 'overview-intro-header-uncheck me-2' : 'd-none'} />
      <Link
        className={`fz-14 me-2 text-black text-decoration-none ${isDone ? 'opacity-50' : ''}`}
        style={{ marginTop: '1px' }}
        to={link}
      >
        {title}
      </Link>
      <ArrowForwardIosIcon sx={{ fontSize: '16px' }} />
    </div>
  );
}

function RenderIntroHeader(props: Props) {
  const {
    fullName, clientListLoad, clientList, vmList, vmListLoad,
  } = props;
  return (
    <div className="w-100 position-relative mb-4">
      <div className="overview-intro-header-bg w-100 h-100" />
      <div className="p-4 px-xl-5">
        <div className="fz-16 fw-bold mb-1">
          {`Hi ${fullName}, Welcome to SmarterVending`}
        </div>
        <div className="fz-14 mb-4 color-secondary">
          Let’s complete your sign up to get the most out of your dashboard
        </div>
        <div className="mb-3 fw-bold">
          <RenderLink
            title="Add your first client"
            isDone={clientList}
            link="/clients/add"
            isLoading={clientListLoad}
          />
        </div>
        {vmListLoad ? <Spinner animation="border" size="sm" /> : (
          <div className="d-flex align-items-center fw-bold">
            <RenderLink
              title="Add a vending machine"
              isDone={vmList}
              link="/vending-machine/add"
              isLoading={vmListLoad}
            />
            <div
              className="rounded-pill mx-3 fz-14"
              style={{
                paddingRight: 12,
                paddingLeft: 12,
                backgroundColor: '#F3F4F8',
                opacity: 0.5,
                paddingTop: '1px',
              }}
            >
              OR
            </div>
            <RenderLink
              title="Add a coffee machine"
              isDone={vmList}
              link="/vending-machine/add"
              isLoading={vmListLoad}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default React.memo(RenderIntroHeader);
